import { render } from "./ModulosEmpresaAsignacion.vue?vue&type=template&id=56c5e3aa&scoped=true"
import script from "./ModulosEmpresaAsignacion.vue?vue&type=script&lang=js"
export * from "./ModulosEmpresaAsignacion.vue?vue&type=script&lang=js"

import "./ModulosEmpresaAsignacion.vue?vue&type=style&index=0&id=56c5e3aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c5e3aa"]])

export default __exports__